// extracted by mini-css-extract-plugin
export var featuredVideoContainer = "styles-module--featuredVideoContainer--33Rww";
export var logoContainer = "styles-module--logoContainer--Uttsb";
export var logo = "styles-module--logo--w3xbR";
export var heroContent = "styles-module--heroContent--2-Obn";